import { makeStyles } from '@mui/styles'
import { MyAccountTheme, MainHeader } from '@dxp-module/themes'

const mainHeaderStyles = makeStyles<MyAccountTheme, object, MainHeader>(
  ({ palette, breakpoints }) => ({
    headerContainer: {
      backgroundColor: palette.secondary.main,
    },
    header: {
      height: '50px',
      textAlign: 'center',
      position: 'relative',
      [breakpoints.down(breakpoints.values.md)]: {
        display: 'grid',
        height: 'auto',
      },
      '& $headerTitle': {
        color: palette.primary.contrastText,
      },
    },
    headerTitle: {
      fontWeight: 'inherit',
      display: 'inline-block',
      color: palette.primary.contrastText,
      lineHeight: '50px',
      [breakpoints.down(breakpoints.values.md)]: {
        gridRow: '2',
      },
    },
    buttonContainer: {
      position: 'relative',
      height: '50px',
      textAlign: 'center',
    },
    headerMenuIcon: {
      color: palette.primary.contrastText,
      display: 'flex',
      // used for svg sizing
      // eslint-disable-next-line @dxp-module/guidance/forbidden-style-keys
      fontSize: '30px',
      position: 'absolute',
      left: '10px',
      top: '10px',
      [breakpoints.up(breakpoints.values.md)]: {
        display: 'none',
      },
    },
    menuButton: {
      width: '60px',
      height: '30px',
      border: `1px solid ${palette.primary.contrastText}`,
      borderRadius: '5px',
      position: 'absolute',
      left: '10px',
      top: '40px',
      [breakpoints.up(breakpoints.values.md)]: {
        display: 'none',
      },
    },
    menuButtonText: {
      fontWeight: 400,
      color: palette.primary.contrastText,
      textTransform: 'uppercase',
      letterSpacing: '1.2px',
    },
    backLinkText: {
      color: palette.primary.contrastText,
      display: 'flex',
      position: 'absolute',
      left: '10px',
      top: '50%',
      transform: 'translateY(-50%)',
      textDecoration: 'underline',
      alignItems: 'center',
      [breakpoints.down(breakpoints.values.md)]: {
        gridRow: '1',
        transform: 'none',
        backgroundColor: palette.primary.main,
        position: 'relative',
        top: 8,
        width: '100%',
        left: 0,
        justifyContent: 'center',
      },
    },
    backLinkIcon: {
      display: 'flex',
      color: palette.primary.contrastText,
      position: 'relative',
      [breakpoints.down(breakpoints.values.md)]: {
        top: 0,
      },
    },
    hideBackLink: {
      display: 'none',
    },
  }),
  { name: 'MyAccount_Common_MainHeader' }
)

export default mainHeaderStyles
